var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating3Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9209",
    "data-name": "Group 9209",
    transform: "translate(-3437 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3437 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3440 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9173",
    "data-name": "Group 9173",
    transform: "translate(3455.494 10390.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8888",
    "data-name": "Path 8888",
    d: "M871.415,39.184a5.992,5.992,0,1,1-5.992-5.992,5.992,5.992,0,0,1,5.992,5.992",
    transform: "translate(-859.431 -33.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8889",
    "data-name": "Path 8889",
    d: "M985.607,39.184a5.992,5.992,0,1,0,5.992-5.992,5.992,5.992,0,0,0-5.992,5.992",
    transform: "translate(-960.578 -33.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8890",
    "data-name": "Path 8890",
    d: "M914.531,148.878H893.912a1.693,1.693,0,0,1,0-3.387h20.618a1.693,1.693,0,1,1,0,3.387",
    transform: "translate(-885.715 -123.215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating3Dark);
export default __webpack_public_path__ + "static/media/rating_3_dark.6262cf3ff871d8401d7ee9dd5d13f355.svg";
export { ForwardRef as ReactComponent };